import { Link } from "react-router-dom";
// import { ConnectButton } from "@rainbow-me/rainbowkit";
import logo from "../assets/images/logo.png";
import WalletButton from "../components/WalletConnectButton";

export const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/#home">
          <img src={logo} alt="rexla-logo" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse flex-row-reverse"
          id="navbarNav"
        >
          <ul className="navbar-nav gap-4 align-items-center">
            <li className="nav-item">
              <a
                className="nav-link active"
                aria-current="page"
                href="https://rexlaglobal.com/about-us/"
                target="_blank"
                rel="noreferrer"
              >
                About Us
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Products
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/ico">
                RXG
              </Link>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://rexlaglobal.com/careers/"
                target="_blank"
              >
                Careers
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://rexlaglobal.com/rwf/"
                target="_blank"
                rel="noreferrer"
              >
                RWF
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://rexlaglobal.com/news/"
                target="_blank"
                rel="noreferrer"
              >
                Innovation
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://rexlaglobal.com/contact/"
                target="_blank"
                rel="noreferrer"
              >
                Contact
              </a>
            </li>
            <li className="nav-item">
              {/*  <a className="btn btn-primary" href="#">
                GET STARTED
              </a> */}
              {/* <ConnectButton /> */}
              <WalletButton className="btn btn-primary wallet-btn" />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
